/*
 * @Date: 2020-03-12 18:12:14
 * @LastEditors: yuanjianlong@aixuexi.com
 * @LastEditTime: 2020-03-27 16:10:01
 * @FilePath: \st-teacher-2020\src\filter\index.ts
 */
// import Vue from 'vue';
import utils from '@/utils';
import date from './date';
/**
  * 定义key为number的interface
  */
interface KeyNumberMap {
  [key: number]: string;
}

// 学期字符串常量
const PERIOD_MAP: KeyNumberMap = {
  1: '春季',
  2: '暑假',
  3: '秋季',
  4: '寒假',
};

// 学期字符串常量
const PERIOD_MAP2: KeyNumberMap = {
  1: '春',
  2: '暑',
  3: '秋',
  4: '寒',
};

// 判断题常量
const JUDGE_ANSWER_MAP: KeyNumberMap = {
  1: '√',
  0: '×',
};

export default (Vue: any) => {
  /**
   * 转换学期
   * 1：春 2：夏 3：秋 4：冬
   */
  Vue.filter('filterPerid', (key: number): string => PERIOD_MAP[key]);

  /**
   * 转换学期-一个字
   * 1：春 2：暑 3：秋 4：寒
   */
  Vue.filter('filterPeridSingle', (key: number): string => PERIOD_MAP2[key]);

  /**
   * 试题的选型
   */
  Vue.filter('questionOption', (value: string): string => String.fromCharCode(parseInt(value, 10) + 65));

  /**
   * 转换判断题的格式
   * 1：√ 0 ×
   */
  Vue.filter('judgeAnswer', (key: number): string => JUDGE_ANSWER_MAP[key]);

  /**
   * 截取字符串加...
   * str: 要截取的字符串
   * length: 截取的长度
   */
  Vue.filter('subStr', (str: string, length: number): string => {
    const size = str.length;
    let strTemp = str;
    if (size > length) {
      strTemp = `${str.substring(0, length - 1)}...`;
    }
    return strTemp;
  });
  /**
   * 返回页面按钮ID 埋点使用
   */
  Vue.filter('aadId', (pathName: string, routeName: string, btnId: string) => {
    if (pathName && routeName && btnId) {
      return utils.getAad(pathName, routeName, btnId);
    }
    return '';
  });

  Vue.filter('trimAll', (str: string) => str.replace(/\s/g, ''));

  Vue.filter('datetime', (value: number, format: string) => date.format(value, format));
};
